import React from "react"
import Components from "../../components"
import PropTypes from "prop-types"
import logo from "../../assets/images/logos/hult-logo-black.svg"
import logoMobile from "../../assets/images/logos/hult-logo-m.svg"

const LandingHeader = ({ blok, cta, fixed }) => (
  <header className={`landing-header${fixed ? " landing-header--fixed" : ""}`}>
    <div className="landing-header__container container container--no-margin">
    <a
            title="Hult"
            href={"/"}
            className="landing-header__branding"
          >
            <img alt="" className="landing-header__logo landing-header__logo--desktop" src={logo} />
            <img alt="" className="landing-header__logo landing-header__logo--mobile" src={logoMobile} />
          </a>
      {cta &&
          cta.map(
            content =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
                className: "btn--cta-color btn--sm-mini",
              })
          )}
    </div>
  </header>
)

LandingHeader.propTypes = {
  blok: PropTypes.shape({
    logo: PropTypes.string,
  }),
}

export default LandingHeader
